module.exports = __webpack_public_path__ + "static/media/image-15-full.1ab3e219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-15-full.jpg
// module id = 355
// module chunks = 0